import React from "react";
import { HomeBG } from "../assets";
import { AuthBox, BackgroundBox } from "../components";

import { ConfirmationTemplate } from "../features";

export const ConfirmationPage: React.FC = () => {
  return (
    <BackgroundBox imageurl={HomeBG}>
      <AuthBox>
        <ConfirmationTemplate />
      </AuthBox>
    </BackgroundBox>
  );
};
